<template>
    <div class="flex" :class="besideDots ? 'gap-0' : 'gap-2'">
        <WishlistButton v-bind="wishlistProduct" :any-size="productStore.forceSizeSelectionActive" :class="buttonClass" icon-size="size-5" />
        <ProductShareButton :class="buttonClass" icon-size="size-5" />
    </div>
</template>

<script setup lang="ts">
import WishlistButton from '@/components/wishlist/WishlistButton.vue';
import { useProductWishlistComposable } from '@/composables/products/ProductWishlistComposable';
import ProductShareButton from '@/pages/product-page/partials/product-image-gallery/partials/ProductShareButton.vue';
import { useProductStore } from '@/stores/products/ProductStore';
import { computed } from 'vue';

const props = defineProps<{
    besideDots?: boolean;
}>();

const productStore = useProductStore();
const wishlistProduct = useProductWishlistComposable();

// The gray border only lifts the buttons off the photo, so beside the dots it goes.
const buttonClass = computed((): string[] => [
    'size-9 md:size-9 lg:size-10 [&_svg]:stroke-[1.5]',
    props.besideDots ? 'border-transparent' : 'border-gray-300',
]);
</script>
